export default {
  institution: {
    name: 'Istanbul Technical University',
    shortName: 'ITU',
    type: 'State University',
    foundationYear: 1773,
    address: 'Ayazaga Campus, Maslak 34469 Sariyer-Istanbul',
    phone: '+90 (212) 285 29 10',
    email: 'contact@itu.edu.tr'
  },
  publications: {
    pageTitle: 'Publications',
    pageDescription: 'Academic publication performance and statistics',
    totalPublications: {
      title: 'Total Articles',
      currentYear: 'Total Articles (2024)',
      lastFiveYears: 'Total Articles (Last Five Years)'
    },
    metrics: {
      publicationsPerFaculty: 'Publications per Faculty Member',
      citationsPerFaculty: 'Citations per Faculty Member',
      q1PublicationsPerFaculty: 'Q1 Publications per Faculty Member',
      totalPublications: 'Total Publications',
      totalCitations: 'Total Citations',
      totalQ1Publications: 'Total Q1 Publications'
    },
    charts: {
      qDistribution: 'Q1-Q2-Q3-Q4 DISTRIBUTION',
      yearlyTrend: 'Yearly Trend',
      q1q2Percentage: 'Q1 + Q2 PERCENTAGE',
      publicationsPerFacultyByFaculty: 'Articles + Reviews per Faculty Member by Faculty',
      publicationsPerFacultyByInstitute: 'Articles + Reviews per Faculty Member by Institute'
    },
    filters: {
      year: 'Year',
      index: 'Index',
      qCategory: 'Q Category',
      department: 'Department',
      publicationType: 'Publication Type',
      searchPlaceholder: 'Search Publication/Author/Keyword...'
    },
    summary: {
      facultyCount: 'Faculty Member Count',
      articleCount: 'Article and Review Count',
      q1q2PerFaculty: 'Q1 + Q2 per Faculty Member',
      mrPerFaculty: 'M-R per Faculty Member',
      q1PerFaculty: 'Q1 per Faculty Member',
      q2PerFaculty: 'Q2 per Faculty Member',
      q1Count: 'Q1',
      q2Count: 'Q2',
      q1q2Count: 'Q1 + Q2',
      q1Percentage: 'Q1 Percentage',
      q2Percentage: 'Q2 Percentage',
      q1q2Percentage: 'Q1 + Q2 Percentage'
    },
    buttons: {
      fullText: 'Full Text',
      details: 'Details'
    }
  },
  common: {
    search: 'Search...',
    notifications: 'Notifications',
    settings: 'Settings',
    darkTheme: 'Dark Theme',
    lightTheme: 'Light Theme',
    profile: 'Profile',
    logout: 'Logout'
  },
  navigation: {
    dashboard: 'Dashboard',
    targets: {
      current: 'Current Targets',
      compare: 'Compare Targets'
    },
    projects: {
      title: 'Projects',
      list: 'Project List'
    },
    publications: {
      title: 'Publications',
      list: 'Publication List',
      departments: 'Department Publications'
    },
    charts: 'Charts'
  }
}; 